type DeepValues<T> = T extends string
  ? T
  : T extends Record<string, unknown>
    ? DeepValues<T[keyof T]>
    : never;

export const TABLE_IDS = {
  ORGANIZATION: {
    SHADOW_AI: {
      TOOLS: 'sai-org-tls',
      BROWSER: 'sai-org-brw',
      RUNNING: 'sai-org-run',
      NETWORK: 'sai-org-net',
    },
    // KIR-3495: the Shadow AI user-scope drill-down renders the same three
    // tables scoped to one member. Distinct ids keep its local preferences
    // (column sizing, page size) from colliding with the org-wide tables above;
    // URL state is disabled on the scoped tables.
    SHADOW_AI_USER_SCOPE: {
      TOOLS: 'sai-ous-tls',
      BROWSER: 'sai-ous-brw',
      RUNNING: 'sai-ous-run',
    },
    AUDIT_LOGS: 'aud-org-log',
    // KIR-4704: Agents Activity → Browser Agent Sites.
    BROWSER_AGENT_SITES: 'bas-org-sit',
    // KIR-3800
    SECURITY_GROUPS: 'sec-org-grp',
    SECURITY_GROUP_MEMBERS: 'sec-org-mem',
  },
  PERSONAL: {
    SHADOW_AI: {
      TOOLS: 'sai-usr-tls',
      BROWSER: 'sai-usr-brw',
      RUNNING: 'sai-usr-run',
    },
  },
} as const;

export type TableId = DeepValues<typeof TABLE_IDS>;
